<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="card">
    <div class="body">
    <div class="col-lg-12">
      <exercises ref="exercise_child" :exercise="exercise" :engine="engine"></exercises>
      <br>
      <ValidationObserver ref="formValidation">
      <b-row>
        <b-col style="text-align:center">
          <a href="https://www.hostmath.com/" target="_blank"><i class="zmdi zmdi-link" /> Editor de Latex</a>
          <b-button @click="bShowLatex = !bShowLatex" class="btn btn-warning ml-2 p-1" size="sm">Ver latex</b-button>
          <span class="mx-3">|</span>
          <strong>Operaciones del ejercicio</strong>
          <b-button v-if="arrayEleOperation.length > 1" @click="removeArrayEleOperation()" class="btn btn-danger ml-2" size="sm">-</b-button>
          <b-button @click="addArrayEleOperation()" class="btn btn-primary ml-2" size="sm">+</b-button>
        </b-col>
      </b-row>
      <br>
      <b-row class="justify-content-center">
          <b-col :md="bShowLatex ? 3 : 5" style="text-align:center"><h6>Ecuación 1</h6></b-col>
          <b-col md="2" style="text-align:center" v-if="bShowLatex"><h6>Visualización</h6></b-col>
          <b-col :md="bShowLatex ? 3 : 5" style="text-align:center"><h6>Ecuación 2</h6></b-col>
          <b-col md="2" style="text-align:center" v-if="bShowLatex"><h6>Visualización</h6></b-col>
          <b-col md="2" style="text-align:center"><h6>Equivalentes</h6></b-col>
      </b-row>
      <div>
        <div v-for="(operation, index) in arrayEleOperation" v-bind:key="index">
            <b-row class="justify-content-center" style="margin-bottom: 10px">
              <b-col :md="bShowLatex ? 3 : 5">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-form-input type="text"
                    v-bind:id="'ECUACION1' + index"
                    v-model="arrayEleOperation[index].ECUACION1" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col md="2" style="text-align:center" v-if="bShowLatex">
                <div v-katex="arrayEleOperation[index].ECUACION1"></div>
              </b-col>
              <b-col :md="bShowLatex ? 3 : 5">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-form-input type="text"
                    v-bind:id="'ECUACION2' + index"
                    v-model="arrayEleOperation[index].ECUACION2" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col md="2" style="text-align:center" v-if="bShowLatex">
                <div v-katex="arrayEleOperation[index].ECUACION2"></div>
              </b-col>
              <b-col md="2">
                <select class="form-control" v-model="arrayEleOperation[index].EQUIVALENTES">
                  <option value="0">No equivalentes </option>
                  <option value="1">Equivalente</option>
                </select>
              </b-col>
            </b-row>
        </div>
      </div>
      <br>
      <b-row>
        <b-col class="text-center">
          <button v-on:click="saveStorage" :disabled="arrayEleOperation.length < 1" class="btn btn-info btn-lg">
            Guardar
          </button>
        </b-col>
      </b-row>
      </ValidationObserver>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import exercises from '../../exercises/exercise.vue';
import engineMixin from '../../../../mixins/engine';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});

export default {
  props: {
    engine: Number,
    exercise: Object,
    type: String,
  },
  mixins: [engineMixin],
  components: {
    exercises,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      bShowLatex: false,
      arrayEleOperation: [],
      // Mapear con los campos de la tabla SUMARESTAALG_CONF
      configuration: {
        ID: null,
        EJERCICIOS_ID: -1,
      },
    };
  },
  methods: {
    removeArrayEleOperation() {
      this.arrayEleOperation.pop();
    },
    addArrayEleOperation() {
      this.arrayEleOperation.push({
        POSICION: this.arrayEleOperation.length + 1,
        ECUACION1: null,
        ECUACION2: null,
        EQUIVALENTES: 0,
      });
    },
    async getMotorData(id) {
      this.loading = true;

      try {
        const response = await this.axios.get('equationsequivalences/getequationsequivalences', {
          params: {
            ejercicios_id: id,
          },
        });
        this.configuration = response.data.config;
        response.data.elements.forEach((element) => {
          this.arrayEleOperation.push({
            POSICION: element.POSICION,
            ECUACION1: element.ECUACION1,
            ECUACION2: element.ECUACION2,
            EQUIVALENTES: element.EQUIVALENTES,
          });
        });
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el ejercicio', { type: 'warning' });
      }

      this.loading = false;
    },
  },
  async mounted() {
    if (this.exercise !== null && (this.exercise.ID !== null && this.exercise.ID !== undefined)) {
      await this.getMotorData(this.exercise.ID);
    }
    // Read from storage data
    this.readFromStorage(this.type);
    this.updatedNumOperation();
  },
};
</script>
